<template>
  <page>
    <template slot="content">
      <help-content :title="'WeRUNの歩数はiPhoneのヘルスケアと異なる原因'">
        <template slot="content">
          <div class="text">アカウントの切り替えや、複数スマホでのログイン、スマホのタイムゾーンを東京以外に設定した場合、WeRUNアプリの歩数はヘルスケアと異なることがあります。<br>また、ヘルスケアの歩数データは他のアプリに更新されることがあります。</div>
        </template>
      </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help10.vue